
export class RefL3rd {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "RefereeName";
    this.scene = "RefereeName";
    this.data = [];
    this.page = 18;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = (options?.game?.referee?.first_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = (options?.game?.referee?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "200";
      }).value = "REFEREE";

      xml.payload.field.find((item) => {
        return item.attr.name === "10401";
      }).value = (options?.game?.referee?.nation?.toUpperCase()  || "");


      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
